module.exports = {"pathContext":{"name":"AccountsOrderBy","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"familyName","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"givenName","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"insertedAt","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-accounts-order-by.json
// module id = 1339
// module chunks = 43615469961136